#import "../../../../common/graphql/EntityDocumentsFields.graphql"
mutation AttachApprovalExtendedDocument(
  $input: AttachApprovalExtendedDocumentInput!
) {
  attachApprovalExtendedDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
